import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { useSvgId } from 'src/hooks';

export const ChannelOtherIcon = memo(
  forwardRef((props, ref) => {
    const svgId = useSvgId();

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <rect
          width="24"
          height="24"
          rx="4"
          fill="#DDEBDB"
        />
        <g clipPath={`url(#${svgId})`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.75562 6.75579C8.14651 5.36489 10.033 4.5835 12 4.5835C13.967 4.5835 15.8535 5.36489 17.2444 6.75579C18.6353 8.14668 19.4167 10.0331 19.4167 12.0002C19.4167 13.9672 18.6353 15.8536 17.2444 17.2445C15.8535 18.6354 13.967 19.4168 12 19.4168C10.033 19.4168 8.14651 18.6354 6.75562 17.2445C5.36472 15.8536 4.58333 13.9672 4.58333 12.0002C4.58333 10.0331 5.36472 8.14668 6.75562 6.75579ZM12 6.0835C10.4308 6.0835 8.92587 6.70686 7.81628 7.81645C6.70669 8.92604 6.08333 10.431 6.08333 12.0002C6.08333 13.5694 6.70669 15.0743 7.81628 16.1839C8.92587 17.2935 10.4308 17.9168 12 17.9168C13.5692 17.9168 15.0741 17.2935 16.1837 16.1839C17.2933 15.0743 17.9167 13.5694 17.9167 12.0002C17.9167 10.431 17.2933 8.92604 16.1837 7.81645C15.0741 6.70686 13.5692 6.0835 12 6.0835Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.186 4.8758C11.5205 5.12007 11.5937 5.58928 11.3494 5.9238C10.5555 7.01092 9.93518 9.32894 9.93518 12.0296C9.93518 14.7232 10.5529 16.9896 11.3542 18.1125C11.5948 18.4497 11.5165 18.918 11.1794 19.1587C10.8422 19.3993 10.3738 19.321 10.1332 18.9838C9.07378 17.4993 8.43518 14.8709 8.43518 12.0296C8.43518 9.19553 9.07111 6.50022 10.138 5.0392C10.3823 4.70468 10.8515 4.63152 11.186 4.8758Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.814 4.8758C13.1485 4.63152 13.6177 4.70468 13.862 5.0392C14.9289 6.50022 15.5648 9.19553 15.5648 12.0296C15.5648 14.8709 14.9262 17.4993 13.8668 18.9838C13.6262 19.321 13.1578 19.3993 12.8206 19.1587C12.4835 18.918 12.4052 18.4497 12.6458 18.1125C13.4471 16.9896 14.0648 14.7232 14.0648 12.0296C14.0648 9.32894 13.4444 7.01092 12.6506 5.9238C12.4063 5.58928 12.4795 5.12007 12.814 4.8758Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.58333 12C4.58333 11.5858 4.91911 11.25 5.33333 11.25H18.6667C19.0809 11.25 19.4167 11.5858 19.4167 12C19.4167 12.4142 19.0809 12.75 18.6667 12.75H5.33333C4.91911 12.75 4.58333 12.4142 4.58333 12Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.3537 15.1113C5.3537 14.6971 5.68949 14.3613 6.1037 14.3613H17.8963C18.3105 14.3613 18.6463 14.6971 18.6463 15.1113C18.6463 15.5255 18.3105 15.8613 17.8963 15.8613H6.1037C5.68949 15.8613 5.3537 15.5255 5.3537 15.1113Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.3537 8.88916C5.3537 8.47495 5.68949 8.13916 6.1037 8.13916H17.8963C18.3105 8.13916 18.6463 8.47495 18.6463 8.88916C18.6463 9.30337 18.3105 9.63916 17.8963 9.63916H6.1037C5.68949 9.63916 5.3537 9.30337 5.3537 8.88916Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
